export default __webpack_public_path__ + "static/media/object.13e0feb2.png";